import { render } from "./LegVolumesHistoryPanel.vue?vue&type=template&id=adf11b26&scoped=true&ts=true"
import script from "./LegVolumesHistoryPanel.vue?vue&type=script&lang=ts"
export * from "./LegVolumesHistoryPanel.vue?vue&type=script&lang=ts"

import "./LegVolumesHistoryPanel.vue?vue&type=style&index=0&id=adf11b26&scoped=true&lang=css"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adf11b26"]])

export default __exports__